import { EmployeeModel } from './../../masters/add-contact/contact.model';
import { AddressModel } from './../../masters/add-address/address.model';
import { DepartmentModel } from './../../masters/add-department/department.model';
export class HospitalModel {
	hospiId: number;
	staRecCode: string;
	compaVaEmail: string;
	compVaHomepage: string;
	compaVaMobilePhone1: string;
	compaVaMobilePhone2: string;
	compaVaName: string;
	compaVaNameEn: string;
	compaNuNumberEmployees: number;
	compaVaVatRegistrationNo: string;
	compaVaWorkFax: string;
	compaVaWorkPhone: string;
	leforId: number;
	admntId: number;
	certiId: number;
	orgsmId: number;
	upload: string;
	hospDepartmentList: DepartmentModel[];
	hospAddressList: AddressModel[];
	hospEmployeeList: EmployeeModel[];
	hospSpecialityList: any[];
	hospSubSpecialityList: any[];
	hospHyperSpecialityList: any[];
	hospiBlProposeInternship;
	hospiBlProposeFormation;
	paCatId;
	pcTypeId;
	paGrpId;
	cotryId;
	townId;
	nationalId;
	code;


}